import React from 'react'
import { SerializedStyles, css } from '@emotion/core'
import { HEADER_HEIGHT } from '@/constants/layout'

type Props = {
  tabComponent: JSX.Element
  customStyle?: SerializedStyles
  isShowFooter?: boolean
  /** ページ送り等で先頭復帰する際のスクロール対象 */
  contentRef?: React.RefObject<HTMLDivElement>
}

export const TabContainer: React.FC<Props> = ({ tabComponent, customStyle, children, isShowFooter, contentRef }) => {
  // subtract TAB HEIGHT - PADDING SPACE
  const containerHeight = `calc(100vh - ${HEADER_HEIGHT}px - 45px - 24px * 2 ${isShowFooter ? '- 59px' : ''})`

  return (
    <>
      {tabComponent}
      <div ref={contentRef} css={[containerStyle, customStyle, css({ height: containerHeight })]}>
        {children}
      </div>
    </>
  )
}

const containerStyle = css({
  width: '100%',
  background: 'white',
  boxShadow: '0px 0px 6px #0000001A',
  borderRadius: '0px 5px 5px',
  position: 'relative',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
})
